import { Amplify } from 'aws-amplify'
import React, { useEffect, useState } from 'react'

import { getAmplifyConfig } from '@/lib/amplify'

import Fallback from './fallback'

interface Props {
  children?: React.ReactNode
}

const ConfigureAmplify: React.FC<Props> = ({ children }) => {
  const [loading, setLoading] = useState(true)

  const handleConfig = async () => {
    const config = await getAmplifyConfig()
    Amplify.configure(config)
    setLoading(false)
  }

  useEffect(() => {
    void handleConfig()
  }, [])

  if (loading) return <Fallback />

  return children
}

export default ConfigureAmplify
